import { Button, Input, Popconfirm, Space } from 'antd';
import MapViewer from '../../MapViewer';
import Card from 'antd/es/card/Card';
import { debounce } from 'lodash';
import { useMemo } from 'react';
import SimpleEditor from '../editor/texteditor/texteditor';

enum ProjectStatusEnum {
  DRAFT = 'draft',
  STAGING = 'staging',
  PRODUCTION = 'production'
}

const MapSection = ({
  maptilerLink,
  saveData,
  maptilerViewState,
  maptilerLayers,
  disabled,
  onChange,
  workflowState,
  remove,
  description
}) => {
  const debouncedOnChange = useMemo(() => debounce(onChange, 500), [onChange]);
  return (
    <div className="mt-2 mb-6">
      <Card>
        <Space className="mb-2" style={{ justifyContent: 'flex-end', width: '100%' }}>
          <Popconfirm
            title="Are you sure you want to remove this map?"
            onConfirm={remove}
            okText="Yes"
            cancelText="No"
            placement="left">
            <Button
              type="primary"
              danger
              disabled={workflowState === ProjectStatusEnum.PRODUCTION ? true : false}>
              Delete Map
            </Button>
          </Popconfirm>
        </Space>
        <Input
          type="text"
          disabled={disabled}
          placeholder="Maptiler Link (https://api.maptiler.com/maps/{mapId}/style.json?key={apiKey})"
          defaultValue={maptilerLink}
          onChange={(e) => onChange(e.target.value, 'maptiler_link')}
        />
        <MapViewer
          maptilerLink={maptilerLink}
          saveData={saveData}
          maptilerViewState={maptilerViewState}
          maptilerLayers={maptilerLayers}
          disabled={disabled}
        />
        <SimpleEditor
          initialData={description}
          onChange={(content) => {
            onChange(content, 'description');
          }}
          editable={workflowState === ProjectStatusEnum.STAGING ? true : false}
        />
      </Card>
    </div>
  );
};

export default MapSection;
